import React from 'react';
import { Tooltip } from '@heroui/react';
import { RefShareOrder } from '../../../../api/services';
import { GroupUserIc, MoneyIc, ChatRoundedIc } from '../../../../components/icons';

interface CampaignStatisticsCellProps {
  order: RefShareOrder;
}

const CampaignStatisticsCell: React.FC<CampaignStatisticsCellProps> = ({ order }) => {
  const formatCurrency = (value: number | string) => {
    const num = Number(value) || 0;
    return `$${num.toFixed(2)}`;
  };

  // Statistics from API
  const subscribers = order.subscribed_count || 0;
  const chats = order.subs?.with_gte_3_chat_messages_count || 0;
  const transactionsTotal = Number(order.transactions_statistic?.total || 0);

  return (
    <div className="flex flex-col gap-[4px] py-2">
      {/* Row: Subscribers, Chats, Total Revenue */}
      <div className="flex items-center gap-[8px]">
        {/* Subscribers */}
        <Tooltip content="Подписчики" placement="top">
          <div className="flex items-center gap-[4px] cursor-pointer">
            <GroupUserIc className="w-[14px] h-[14px]" />
            <span className="text-[12px] text-[#11181c] leading-[16px]">{subscribers}</span>
          </div>
        </Tooltip>

        {/* Chats */}
        <Tooltip content="Сообщения" placement="top">
          <div className="flex items-center gap-[4px] cursor-pointer">
            <ChatRoundedIc className="w-[14px] h-[14px]" />
            <span className="text-[12px] text-[#11181c] leading-[16px]">{chats}</span>
          </div>
        </Tooltip>

        {/* Total Revenue */}
        <Tooltip content="Всего поступлений" placement="top">
          <div className="flex items-center gap-[4px] cursor-pointer">
            <MoneyIc className="w-[14px] h-[14px]" />
            <span className="text-[12px] text-[#11181c] leading-[16px]">{formatCurrency(transactionsTotal)}</span>
          </div>
        </Tooltip>
      </div>
    </div>
  );
};

export default CampaignStatisticsCell;
